import React, {Component} from 'react'
import PropTypes from 'prop-types'
import CloseIcon from 'react-icons/lib/md/close'

import api from './helpers/api'

const GUIDES = ['Jean', 'Charlie', 'Kevin']
const SPOTS = {
  morning: 'Matin',
  afternoon: 'Aprèm',
}

class Avail extends Component {
  static propTypes = {
    calendar: PropTypes.object,
    path: PropTypes.string.isRequired,
  }

  state = {
    showForm: false,
    split: !!(this.props.calendar && !this.props.calendar.day),
    loading: false,
    submitting: false,
  }

  componentWillReceiveProps(props) {
    if (this.state.split && props.calendar && props.calendar.day) {
      this.setState({
        split: false,
      })
    } else if (!this.state.split && props.calendar && !props.calendar.day) {
      this.setState({
        split: true,
      })
    }
  }

  handleToggleForm = () => {
    this.setState({
      showForm: !this.state.showForm,
      submitting: false,
    })
  }

  handleSplit = (event) => {
    this.setState({
      split: event.target.value === 'halfday',
    })
  }

  handleSubmit = (event) => {
    event.preventDefault()

    const request = {
      path: this.props.path,
    }

    const {elements} = event.target
    Object.keys(SPOTS).forEach((spot) => {
      request[spot] = {}
      GUIDES.forEach((guide) => {
        request[spot][guide] = elements[spot + '/' + guide].checked
      })
    })

    this.setState({
      submitting: true,
    })

    api.post('availability', request)
    .then(this.handleToggleForm)
    .catch((error) => {
      alert(error.message)
      this.setState({submitting: false})
    })
  }

  renderForm = () => {
    const {calendar} = this.props

    const {submitting} = this.state

    return (
      <form className="inline avail" onSubmit={this.handleSubmit}>
        {Object.entries(SPOTS).map(([spot, label]) => {
          const data = (calendar && calendar[spot]) || {}
          const unavailable = data.unavailable || {}
          return (
            <div key={spot}>
              <span>{label} :</span>
              {GUIDES.map((guide) =>
                <label key={guide} className="line">
                  <input type="checkbox" name={spot + '/' + guide} defaultChecked={!unavailable[guide]} />
                  {guide}
                </label>
              )}
            </div>
          )
        })}
        <button type="submit" disabled={submitting}>Enregistrer</button>
        <button onClick={this.handleToggleForm} className="close"><CloseIcon /></button>
      </form>
    )
  }

  render() {
    if (this.state.showForm) {
      return this.renderForm()
    }

    const {calendar} = this.props

    return (
      <div className="clickable" onClick={this.handleToggleForm}>
        {Object.entries(SPOTS).map(([spot, label]) => {
          const data = (calendar && calendar[spot]) || {}
          const unavailable = data.unavailable || {}
          const available = GUIDES.filter((guide) => !unavailable[guide])

          return (
            <div key={spot} className={available.length === GUIDES.length ? 'open' : available.length === 0 ? 'closed' : 'partial'}>
              <span>{label} : </span>
              {available.length > 0 ? available.join(', ') : 'Fermé'}
            </div>
          )
        })}
      </div>
    )
  }
}

export default Avail
